import React from "react";

import close from "./../../../UI/general/close.svg";

interface Props {
  showTooltip: boolean;
  propertiesData: any;
  filteredProperty: any;
  clientX: string;
  clientY: string;
  handleHideTooltip: any;
  handleamenitiesMenySelection: any;
  handleSetPropertyInQuotation: any;
  handleRemovePropertyInQuotation: any;
  quotationProperties: any;
  colors: any;
  isQuotation: any;
}

interface State {
  filter: any;
  attributesValues: any;
}

class PropertiesTooltip extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filter: {},
      attributesValues: {},
    };
  }

  componentDidMount(): void {
    var tempAttributesValuesArray: any = {};
    this.props.propertiesData.attributes.map(
      (attribute: any, index: number) =>
        (tempAttributesValuesArray[attribute.id] = {
          type: attribute.type,
          value: attribute.name,
          parent: attribute.padre,
        })
    );

    this.setState(
      {
        attributesValues: tempAttributesValuesArray,
      },
      () => {
        var filter = this.props.propertiesData.property.filter(
          (property: any) => property.id === this.props.filteredProperty
        );
        this.setState({
          filter: filter[0],
        });
      }
    );
  }

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.showTooltip
            ? "tooltip-mobile fade-in"
            : "tooltip-mobile fade-out"
        }
        style={{}}
      >
        <div
          className="tooltip-close-container"
          onClick={() => {
            this.props.handleHideTooltip();
          }}
        >
          <img src={close} alt=""></img>
        </div>
        {this.state.filter ? (
          <div className="info-apto-container">
            <div className="property-name-tooltip">
              {"Apto " + this.state.filter.property}
            </div>
            <div className="hirarchical-tooltip-container">
              {this.state.filter.values
                ? this.state.filter.values.map(
                    (attribute: any, index: number) =>
                      this.state.attributesValues[attribute.attribute].type ===
                      "Hierarchical" ? (
                        <React.Fragment>
                          {this.state.attributesValues[attribute.attribute]
                            .parent === null ? (
                            <div>{attribute.value}</div>
                          ) : this.state.attributesValues[attribute.attribute]
                              .parent !== null ? (
                            <div>{" / " + attribute.value}</div>
                          ) : null}
                        </React.Fragment>
                      ) : null
                  )
                : null}
            </div>
            <hr></hr>
            <div className="attribute-values-tooltip">
              {this.state.filter.values
                ? this.state.filter.values.map(
                    (attribute: any, index: number) =>
                      this.state.attributesValues[attribute.attribute].type !==
                      "Hierarchical" ? (
                        <div>
                          {this.state.attributesValues[attribute.attribute]
                            .value +
                            ": " +
                            attribute.value}
                        </div>
                      ) : null
                  )
                : null}
            </div>
            {this.state.filter.galleries &&
            this.state.filter.galleries.length > 0 ? (
              <hr></hr>
            ) : null}
            {this.state.filter.galleries &&
            this.state.filter.galleries.length > 0 ? (
              <div className="tooltip-galleries">
                {this.state.filter.galleries.map(
                  (gallery: any, index: number) => (
                    <div
                      className="tooltip-gallery-individual-item"
                      onClick={() => {
                        this.props.handleamenitiesMenySelection(gallery);
                      }}
                    >
                      <img src={gallery.icon} alt="" />
                      <div>{gallery.name}</div>
                    </div>
                  )
                )}
              </div>
            ) : null}

            {this.props.isQuotation ? <hr></hr> : null}
            {this.props.isQuotation ? (
              <div className="tooltip-quotation">
                {this.props.quotationProperties.some(
                  (e: any) => e.id === this.state.filter.id
                ) ? (
                  <div
                    className="tooltip-quotation-individual-item-lista"
                    key={"tooltip-quotation-lista"}
                    style={{ backgroundColor: this.props.colors.main_buttons }}
                    onClick={() =>
                      this.props.handleRemovePropertyInQuotation(
                        this.state.filter
                      )
                    }
                  >
                    <div>En Lista</div>
                  </div>
                ) : (
                  <div
                    className="tooltip-quotation-individual-item"
                    key={"tooltip-quotation"}
                    onClick={() =>
                      this.props.handleSetPropertyInQuotation(this.state.filter)
                    }
                  >
                    <div>Agregar a cotización</div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default PropertiesTooltip;
